/**
 * WordPress dependencies
 */
import { SVG, Path } from '@wordpress/primitives';

const justifySpaceBetweenVertical = (
	<SVG xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
		<Path d="M7 4H17V8L7 8V4ZM7 16L17 16V20L7 20V16ZM20 11.25H4V12.75H20V11.25Z" />
	</SVG>
);

export default justifySpaceBetweenVertical;
